








































import { defineComponent, reactive, toRefs, watch } from '@vue/composition-api';

export default defineComponent({
  name: 'ScheduleCreateForm',

  props: {
    open: {
      type: Boolean,
      default: () => false,
    }
  },

  setup(props, { emit }) {
    const state = reactive({
      name: '',
      days: '',
    });

    watch(() => props.open, (value: boolean) => {
      if (!value) {
        resetForm();
      }
    });

    /**
     * Handler fro close event
     * */
    function closeEventHandler() {
      emit('close');
      resetForm();
    }

    /**
     * Reset form state
     * */
    function resetForm() {
      state.name = '';
      state.days = '';
    }

    /**
     * Handler for submit event
     * */
    function submitEventHandler() {
      emit('create-schedule', { name: state.name, days: state.days });
    }

    return {
      ...toRefs(state),
      closeEventHandler,
      submitEventHandler,
    };
  }
});
